// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import CardDesignerSurface from './CardDesignerSurface';
import DraggableElement from './DraggableElement';
import CardElementPeer from './DesignerPeers/CardElementPeer';

export default abstract class BaseInventoryItem extends DraggableElement {
    readonly element: HTMLElement;

    protected internalRender(): HTMLElement {
        return this.element;
    }

    constructor(element: HTMLElement) {
        super();
        this.element = element;
    }

    renderDragVisual(): HTMLElement {
        return this.internalRender()
            .querySelector('img')
            .cloneNode() as HTMLElement;
    }

    abstract createPeer(designer: CardDesignerSurface): CardElementPeer;
}
